// Parent-Seite der Kundenportal-iFrames (Content-Element avlpackage_kundenportal_iframe):
// setzt die iFrame-Hoehe aus den Resize-Nachrichten des Providers (iframe.js in avl_kundenportal)
// und verarbeitet Navigations-/Scroll-Anfragen. Gemeinsame Quelle fuer Hauptseite
// (includeJSFooter in avl_package) und Kundenportal (Import in dessen main.js).
(() => {
  const MESSAGE_TYPE = 'avlKundenportal:iframeResize';
  const REQUEST_TYPE = 'avlKundenportal:requestResize';
  const iframes = Array.from(document.querySelectorAll('.kundenportal-iframe__frame'));
  if (!iframes.length) {
    return;
  }
  const iframeMeta = new Map();
  const getIframeOrigin = iframe => {
    const src = iframe.getAttribute('src');
    if (!src) {
      return null;
    }
    try {
      return new URL(src, window.location.href).origin;
    } catch (error) {
      return null;
    }
  };
  const setIframeHeight = (iframe, height) => {
    if (!Number.isFinite(height)) {
      return;
    }
    const clamped = Math.max(0, Math.round(height));
    if (!clamped) {
      return;
    }
    const iframeState = iframeMeta.get(iframe);
    const current = iframeState ? iframeState.height : null;
    if (current === clamped) {
      return;
    }
    iframe.style.setProperty('height', `${clamped}px`);
    iframeMeta.set(iframe, {
      ...iframeMeta.get(iframe),
      height: clamped
    });
  };
  const requestResize = iframe => {
    const meta = iframeMeta.get(iframe);
    if (!meta || !meta.contentWindow) {
      return;
    }
    meta.contentWindow.postMessage({
      type: REQUEST_TYPE
    }, meta.origin || '*');
  };
  const getDocumentHeight = doc => {
    if (!doc) {
      return 0;
    }
    const {
      body
    } = doc;
    const html = doc.documentElement;
    if (!body || !html) {
      return 0;
    }
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  };
  const initSameOriginAutoResize = iframe => {
    try {
      const doc = iframe.contentDocument;
      if (!doc) {
        return;
      }
      const schedule = () => {
        setIframeHeight(iframe, getDocumentHeight(doc));
      };
      schedule();
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(doc.documentElement);
        if (doc.body) {
          resizeObserver.observe(doc.body);
        }
      }
      if (typeof MutationObserver !== 'undefined') {
        const mutationObserver = new MutationObserver(schedule);
        mutationObserver.observe(doc.documentElement, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      if (doc.fonts && typeof doc.fonts.addEventListener === 'function') {
        doc.fonts.addEventListener('loadingdone', schedule);
      }
      window.addEventListener('resize', schedule);
    } catch (error) {
      String(error);
    }
  };
  iframes.forEach(iframe => {
    iframeMeta.set(iframe, {
      origin: getIframeOrigin(iframe),
      contentWindow: null,
      height: null
    });
    iframe.addEventListener('load', () => {
      const meta = iframeMeta.get(iframe) || {};
      iframeMeta.set(iframe, {
        ...meta,
        contentWindow: iframe.contentWindow
      });
      initSameOriginAutoResize(iframe);
      requestResize(iframe);
    });
  });
  window.addEventListener('message', event => {
    const {
      data
    } = event;
    if (!data || typeof data !== 'object') {
      return;
    }
    if (data.type === 'avlKundenportal:navigate') {
      if (data.url && typeof data.url === 'string') {
        window.location.href = data.url;
      }
      return;
    }
    if (data.type === 'avlKundenportal:scrollToIframe') {
      const sourceIframe = iframes.find(iframe => iframe.contentWindow === event.source);
      if (sourceIframe) {
        const iframeTop = sourceIframe.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: iframeTop,
          behavior: 'smooth'
        });
      }
      return;
    }
    if (data.type !== MESSAGE_TYPE) {
      return;
    }
    const sourceIframe = iframes.find(iframe => iframe.contentWindow === event.source);
    if (!sourceIframe) {
      return;
    }
    const meta = iframeMeta.get(sourceIframe);
    if (meta && meta.origin && event.origin !== meta.origin) {
      try {
        const expected = new URL(meta.origin);
        const actual = new URL(event.origin);
        if (expected.hostname !== actual.hostname) {
          return;
        }
        iframeMeta.set(sourceIframe, {
          ...meta,
          origin: event.origin
        });
      } catch (error) {
        return;
      }
    }
    setIframeHeight(sourceIframe, Number(data.height));
  }, true);
})();